import { Injectable } from '@angular/core';
import { AuthenticationResult } from '@azure/msal-browser';
import { UserRole, UserRoles } from '@core/constants';
import { User } from '../models/user.model';
import { IUserService } from './user.service.interface';
import { UserService } from './user.service';

@Injectable()
export class UserDevService extends UserService implements IUserService {
    private isDevelopmentAdmin: boolean | null = null;

    public override isUserAdmin(): boolean {
        if (this.isDevelopmentAdmin !== null) {
            return this.isDevelopmentAdmin;
        }
        return super.isUserAdmin();
    }

    public override setAdmin(): void {
        this.isDevelopmentAdmin = true;
        this.updateCurrentUserRole(true, UserRoles.Admin);
    }

    public override setUser(): void {
        this.isDevelopmentAdmin = false;
        this.updateCurrentUserRole(false, UserRoles.User);
    }

    public override createUserFromAuthenticationResult(authResult: AuthenticationResult): User {
        const user = super.createUserFromAuthenticationResult(authResult);

        if (this.isDevelopmentAdmin !== null) {
            return (
                this.updateCurrentUserRole(
                    this.isDevelopmentAdmin,
                    this.isDevelopmentAdmin ? UserRoles.Admin : UserRoles.User,
                    user
                ) ?? user
            );
        }

        return user;
    }

    protected override hasAdminRole(roles: readonly UserRole[]): boolean {
        if (this.isDevelopmentAdmin !== null) {
            return this.isDevelopmentAdmin;
        }
        return super.hasAdminRole(roles);
    }

    private updateCurrentUserRole(isAdmin: boolean, roleToSet: UserRole, sourceUser?: User): User | null {
        const user = sourceUser ?? this.currentUserValue;
        if (!user) {
            return null;
        }

        const filteredRoles = user.accessToken.roles.filter(
            role => role !== UserRoles.Admin && role !== UserRoles.KeyUser && role !== UserRoles.User
        );

        const updatedUser: User = {
            ...user,
            isAdmin,
            accessToken: {
                ...user.accessToken,
                roles: [...filteredRoles, roleToSet]
            }
        };

        this.currentUserSubject.next(updatedUser);
        return updatedUser;
    }
}
